import { BaseModel } from '@crud';

export class InvoiceConceptoComplementoConceptoModel extends BaseModel {

}
